const svg = (body: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 40">${body}</svg>`;

const barsH = (...colors: string[]) => {
  const height = 40 / colors.length;
  return svg(
    colors
      .map(
        (fill, index) =>
          `<rect x="0" y="${index * height}" width="60" height="${height + 0.4}" fill="${fill}"/>`,
      )
      .join(''),
  );
};

const barsV = (...colors: string[]) => {
  const width = 60 / colors.length;
  return svg(
    colors
      .map(
        (fill, index) =>
          `<rect x="${index * width}" y="0" width="${width + 0.4}" height="40" fill="${fill}"/>`,
      )
      .join(''),
  );
};

const nordic = (field: string, cross: string, outline?: string) => {
  if (!outline) {
    return svg(
      `<rect width="60" height="40" fill="${field}"/><rect x="16" width="8" height="40" fill="${cross}"/><rect y="16" width="60" height="8" fill="${cross}"/>`,
    );
  }
  return svg(
    `<rect width="60" height="40" fill="${field}"/><rect x="14" width="12" height="40" fill="${outline}"/><rect y="14" width="60" height="12" fill="${outline}"/><rect x="16" width="8" height="40" fill="${cross}"/><rect y="16" width="60" height="8" fill="${cross}"/>`,
  );
};

const FLAGS: Record<string, string> = {
  gb: svg(
    `<rect width="60" height="40" fill="#012169"/><path d="M0 0 L60 40 M60 0 L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0 L60 40 M60 0 L0 40" stroke="#C8102E" stroke-width="4"/><path d="M30 0 V40 M0 20 H60" stroke="#fff" stroke-width="14"/><path d="M30 0 V40 M0 20 H60" stroke="#C8102E" stroke-width="8"/>`,
  ),
  de: barsH('#000', '#DD0000', '#FFCE00'),
  fr: barsV('#0055A4', '#fff', '#EF4135'),
  sa: svg(
    `<rect width="60" height="40" fill="#006C35"/><path d="M14 27 H40" stroke="#fff" stroke-width="1.6" fill="none"/><path d="M40 27 c3 5 8 4 9 1" stroke="#fff" stroke-width="1.6" fill="none"/>`,
  ),
  it: barsV('#009246', '#fff', '#CE2B37'),
  es: svg(`<rect width="60" height="40" fill="#AA151B"/><rect y="10" width="60" height="20" fill="#F1BF00"/>`),
  br: svg(
    `<rect width="60" height="40" fill="#009B3A"/><path d="M30 5 L54 20 L30 35 L6 20 Z" fill="#FFDF00"/><circle cx="30" cy="20" r="7" fill="#002776"/>`,
  ),
  my: svg(
    `<rect width="60" height="40" fill="#fff"/><g fill="#CC0001"><rect width="60" height="2.8"/><rect y="5.7" width="60" height="2.8"/><rect y="11.4" width="60" height="2.8"/><rect y="17.1" width="60" height="2.8"/><rect y="22.8" width="60" height="2.8"/><rect y="28.5" width="60" height="2.8"/><rect y="34.2" width="60" height="2.8"/></g><rect width="28" height="20" fill="#010066"/><circle cx="12" cy="10" r="5" fill="#FC0"/><circle cx="14.2" cy="10" r="4" fill="#010066"/>`,
  ),
  th: svg(`<rect width="60" height="40" fill="#A51931"/><rect y="7" width="60" height="26" fill="#fff"/><rect y="13" width="60" height="14" fill="#2D2A4A"/>`),
  cn: svg(
    `<rect width="60" height="40" fill="#DE2910"/><path d="M14 7.5 l1.5 4.6 H20 l-3.8 2.8 1.5 4.6 L14 16.7 10.3 19.5 11.8 14.9 8 12.1 h4.5 z" fill="#FFDE00"/>`,
  ),
  tw: svg(
    `<rect width="60" height="40" fill="#FE0000"/><rect width="30" height="22" fill="#000095"/><circle cx="15" cy="11" r="5" fill="#fff"/><circle cx="15" cy="11" r="2.2" fill="#000095"/>`,
  ),
  id: barsH('#CE1126', '#fff'),
  ph: svg(
    `<rect width="60" height="20" fill="#0038A8"/><rect y="20" width="60" height="20" fill="#CE1126"/><path d="M0 0 L26 20 L0 40 Z" fill="#fff"/><circle cx="9" cy="20" r="3" fill="#FCD116"/>`,
  ),
  vn: svg(
    `<rect width="60" height="40" fill="#DA251D"/><path d="M30 9 l2.2 6.6 h7 l-5.6 4.1 2.1 6.6 L30 22.2 l-5.7 4.1 2.1-6.6 -5.6-4.1 h7 z" fill="#FF0"/>`,
  ),
  ru: barsH('#fff', '#0039A6', '#D52B1E'),
  jp: svg(`<rect width="60" height="40" fill="#fff"/><circle cx="30" cy="20" r="8" fill="#BC002D"/>`),
  kr: svg(
    `<rect width="60" height="40" fill="#fff"/><path d="M30 12 a8 8 0 0 1 0 16 a4 4 0 0 1 0 -8 a4 4 0 0 0 0 -8" fill="#0047A0"/><path d="M30 12 a8 8 0 0 0 0 16 a4 4 0 0 0 0 -8 a4 4 0 0 1 0 -8" fill="#CD2E3A"/><g stroke="#000" stroke-width="1.2"><path d="M12 10 h6 M12 12.2 h6 M12 14.4 h6"/><path d="M42 10 h6 M42 12.2 h6 M42 14.4 h6"/><path d="M12 25.6 h6 M12 27.8 h6 M12 30 h6"/><path d="M42 25.6 h6 M42 27.8 h6 M42 30 h6"/></g>`,
  ),
  in: svg(
    `<rect width="60" height="13.4" fill="#FF9933"/><rect y="13.3" width="60" height="13.4" fill="#fff"/><rect y="26.6" width="60" height="13.4" fill="#138808"/><circle cx="30" cy="20" r="4.2" fill="none" stroke="#000080" stroke-width="0.9"/>`,
  ),
  bd: svg(`<rect width="60" height="40" fill="#006A4E"/><circle cx="26" cy="20" r="8" fill="#F42A41"/>`),
  pk: svg(
    `<rect width="60" height="40" fill="#01411C"/><rect width="15" height="40" fill="#fff"/><circle cx="36" cy="20" r="7" fill="#fff"/><circle cx="38.2" cy="18.6" r="5.6" fill="#01411C"/>`,
  ),
  tr: svg(
    `<rect width="60" height="40" fill="#E30A17"/><circle cx="24" cy="20" r="8" fill="#fff"/><circle cx="26.6" cy="20" r="6.4" fill="#E30A17"/><path d="M34 20 l-2.2 1.4 .6-2.4 -2-1.6 2.5-.2 L34 15 l.9 2.2 2.5.2 -2 1.6 .6 2.4 z" fill="#fff"/>`,
  ),
  pl: barsH('#fff', '#DC143C'),
  nl: barsH('#AE1C28', '#fff', '#21468B'),
  se: nordic('#006AA7', '#FECC00'),
  no: nordic('#BA0C2F', '#00205B', '#fff'),
  dk: nordic('#C60C30', '#fff'),
  fi: nordic('#fff', '#003580'),
  is: nordic('#02529C', '#DC1E35', '#fff'),
  gr: svg(
    `<rect width="60" height="40" fill="#0D5EAF"/><g fill="#fff"><rect y="4.4" width="60" height="4.4"/><rect y="13.3" width="60" height="4.4"/><rect y="22.2" width="60" height="4.4"/><rect y="31.1" width="60" height="4.4"/></g><rect width="24" height="22" fill="#0D5EAF"/><rect x="10" width="4" height="22" fill="#fff"/><rect y="9" width="24" height="4" fill="#fff"/>`,
  ),
  il: svg(
    `<rect width="60" height="40" fill="#fff"/><rect y="5" width="60" height="5" fill="#0038B8"/><rect y="30" width="60" height="5" fill="#0038B8"/><path d="M30 12 L36 22 H24 Z M30 26 L24 16 H36 Z" fill="none" stroke="#0038B8" stroke-width="1.3"/>`,
  ),
  ua: barsH('#005BBB', '#FFD500'),
  by: svg(
    `<rect width="60" height="26" fill="#C8313E"/><rect y="26" width="60" height="14" fill="#4AA657"/><rect width="8" height="40" fill="#fff"/><path d="M2 4 v6 M4 2 v8 M6 4 v6" stroke="#C8313E" stroke-width="0.8"/>`,
  ),
  cz: svg(`<rect width="60" height="20" fill="#fff"/><rect y="20" width="60" height="20" fill="#D7141A"/><path d="M0 0 L26 20 L0 40 Z" fill="#11457E"/>`),
  sk: svg(
    `<rect width="60" height="13.4" fill="#fff"/><rect y="13.3" width="60" height="13.4" fill="#0B4EA2"/><rect y="26.6" width="60" height="13.4" fill="#EE1C25"/><path d="M8 8 h10 v16 H8 z" fill="#fff" stroke="#EE1C25"/>`,
  ),
  ro: barsV('#002B7F', '#FCD116', '#CE1126'),
  hu: barsH('#CE2939', '#fff', '#477050'),
  bg: barsH('#fff', '#00966E', '#D62612'),
  hr: svg(
    `<rect width="60" height="13.4" fill="#FF0000"/><rect y="13.3" width="60" height="13.4" fill="#fff"/><rect y="26.6" width="60" height="13.4" fill="#171796"/><rect x="26" y="12" width="8" height="12" fill="#FF0000"/>`,
  ),
  rs: svg(
    `<rect width="60" height="13.4" fill="#C6363C"/><rect y="13.3" width="60" height="13.4" fill="#0C4076"/><rect y="26.6" width="60" height="13.4" fill="#fff"/>`,
  ),
  ba: svg(`<rect width="60" height="40" fill="#002395"/><path d="M16 0 H60 L16 40 H0 Z" fill="#FECB00"/>`),
  si: svg(
    `<rect width="60" height="13.4" fill="#fff"/><rect y="13.3" width="60" height="13.4" fill="#003DA5"/><rect y="26.6" width="60" height="13.4" fill="#ED1C24"/><path d="M8 6 h8 v10 H8 z" fill="#003DA5"/>`,
  ),
  al: svg(`<rect width="60" height="40" fill="#E41E20"/><path d="M30 8 l4 8 8 2-6 5 2 8-8-4-8 4 2-8-6-5 8-2 z" fill="#000"/>`),
  mk: svg(
    `<rect width="60" height="40" fill="#D20000"/><g stroke="#F8E92E" stroke-width="3"><path d="M30 20 L30 0 M30 20 L60 0 M30 20 L60 20 M30 20 L60 40 M30 20 L30 40 M30 20 L0 40 M30 20 L0 20 M30 20 L0 0"/></g><circle cx="30" cy="20" r="5" fill="#F8E92E"/>`,
  ),
  lt: barsH('#FDB913', '#006A44', '#C1272D'),
  lv: svg(`<rect width="60" height="40" fill="#9E3039"/><rect y="16" width="60" height="8" fill="#fff"/>`),
  ee: barsH('#0072CE', '#000', '#fff'),
  ir: svg(
    `<rect width="60" height="13.4" fill="#239F40"/><rect y="13.3" width="60" height="13.4" fill="#fff"/><rect y="26.6" width="60" height="13.4" fill="#DA0000"/>`,
  ),
  af: barsV('#000', '#C8102E', '#007A36'),
  ku: svg(
    `<rect width="60" height="13.4" fill="#E31D1C"/><rect y="13.3" width="60" height="13.4" fill="#fff"/><rect y="26.6" width="60" height="13.4" fill="#278E43"/><circle cx="30" cy="20" r="5" fill="#FFD400"/>`,
  ),
  az: svg(
    `<rect width="60" height="13.4" fill="#00B5E2"/><rect y="13.3" width="60" height="13.4" fill="#EF3340"/><rect y="26.6" width="60" height="13.4" fill="#509E2F"/><circle cx="28" cy="20" r="4" fill="#fff"/><circle cx="29.4" cy="20" r="3.2" fill="#EF3340"/>`,
  ),
  kz: svg(`<rect width="60" height="40" fill="#00AFCA"/><circle cx="30" cy="20" r="7" fill="#FFD700"/>`),
  uz: svg(
    `<rect width="60" height="12" fill="#0099B5"/><rect y="12" width="60" height="2.5" fill="#CE1126"/><rect y="14.5" width="60" height="11" fill="#fff"/><rect y="25.5" width="60" height="2.5" fill="#CE1126"/><rect y="28" width="60" height="12" fill="#1EB53A"/>`,
  ),
  ge: svg(
    `<rect width="60" height="40" fill="#fff"/><rect x="26" width="8" height="40" fill="#FF0000"/><rect y="16" width="60" height="8" fill="#FF0000"/><rect x="6" y="4" width="8" height="8" fill="none" stroke="#FF0000"/><rect x="46" y="4" width="8" height="8" fill="none" stroke="#FF0000"/><rect x="6" y="28" width="8" height="8" fill="none" stroke="#FF0000"/><rect x="46" y="28" width="8" height="8" fill="none" stroke="#FF0000"/>`,
  ),
  am: barsH('#D90012', '#0033A0', '#F2A800'),
  mn: barsV('#DA2032', '#0066B3', '#DA2032'),
  np: svg(
    `<rect width="60" height="40" fill="#f6f3ec"/><path d="M8 4 H34 L16 18 H32 L8 36 Z" fill="#DC143C" stroke="#003893" stroke-width="2"/>`,
  ),
  lk: svg(
    `<rect width="60" height="40" fill="#FFBE29"/><rect x="8" width="10" height="40" fill="#00534E"/><rect x="18" width="8" height="40" fill="#EB7400"/><rect x="26" width="30" height="40" fill="#8D153A"/>`,
  ),
  kh: svg(`<rect width="60" height="40" fill="#032EA1"/><rect y="10" width="60" height="20" fill="#E00025"/><rect x="22" y="14" width="16" height="12" fill="#fff"/>`),
  la: svg(`<rect width="60" height="40" fill="#CE1126"/><rect y="10" width="60" height="20" fill="#002868"/><circle cx="30" cy="20" r="6" fill="#fff"/>`),
  mm: svg(
    `<rect width="60" height="10" fill="#FECB00"/><rect y="10" width="60" height="10" fill="#34B233"/><rect y="20" width="60" height="10" fill="#EA2839"/><rect y="30" width="60" height="10" fill="#fff"/><path d="M30 14 l1.6 4.4 h4.6 l-3.7 2.8 1.4 4.4 L30 23 l-3.9 2.6 1.4-4.4 -3.7-2.8 h4.6 z" fill="#fff"/>`,
  ),
  ke: svg(
    `<rect width="60" height="40" fill="#fff"/><rect height="12" width="60" fill="#000"/><rect y="14" height="12" width="60" fill="#BB0000"/><rect y="28" height="12" width="60" fill="#006600"/><ellipse cx="30" cy="20" rx="5" ry="8" fill="#fff" stroke="#000"/>`,
  ),
  ng: barsV('#008751', '#fff', '#008751'),
  et: barsH('#078930', '#FCDD09', '#DA121A'),
  so: svg(`<rect width="60" height="40" fill="#4189DD"/><path d="M30 10 l2 6 h6 l-5 4 2 6 -5-4 -5 4 2-6 -5-4 h6 z" fill="#fff"/>`),
  za: svg(
    `<path fill="#DE3831" d="M0 0h60v40H0z"/><path fill="#002395" d="M0 20h60v20H0z"/><path fill="#fff" d="M0 0 L30 20 L0 40"/><path fill="#007A4D" d="M0 6 L22 20 L0 34"/><path fill="#FFB612" d="M0 0 L34 20 L0 40 h8 L40 20 L8 0z"/>`,
  ),
  ie: barsV('#169B62', '#fff', '#FF883E'),
  wls: svg(
    `<rect width="60" height="20" fill="#fff"/><rect y="20" width="60" height="20" fill="#C8102E"/><path d="M18 8 l8 6 -8 6 -2-4 H8 l6-2 -6-2 h8 z" fill="#00AB4E"/>`,
  ),
  cat: svg(
    `<g fill="#FCDD09"><rect width="60" height="4.5"/><rect y="8.9" width="60" height="4.4"/><rect y="17.8" width="60" height="4.4"/><rect y="26.7" width="60" height="4.4"/><rect y="35.6" width="60" height="4.4"/></g><g fill="#DA121A"><rect y="4.4" width="60" height="4.5"/><rect y="13.3" width="60" height="4.5"/><rect y="22.2" width="60" height="4.5"/><rect y="31.1" width="60" height="4.5"/></g>`,
  ),
  eus: svg(
    `<rect width="60" height="40" fill="#D52B1E"/><path d="M0 0 L60 40 M60 0 L0 40" stroke="#009B48" stroke-width="6"/><path d="M30 0 V40 M0 20 H60" stroke="#fff" stroke-width="6"/>`,
  ),
  gal: svg(`<rect width="60" height="40" fill="#fff"/><path d="M0 40 L30 8 L60 40" fill="#2E77BC"/>`),
  mt: barsV('#fff', '#CF142B'),
  hk: svg(`<rect width="60" height="40" fill="#DE2910"/><circle cx="30" cy="20" r="7" fill="none" stroke="#fff" stroke-width="1.4"/>`),
  pt: svg(
    `<rect width="24" height="40" fill="#006600"/><rect x="24" width="36" height="40" fill="#FF0000"/><circle cx="24" cy="20" r="7" fill="#FFCC00"/>`,
  ),
  ht: svg(
    `<rect width="60" height="20" fill="#00209F"/><rect y="20" width="60" height="20" fill="#D21034"/><rect x="22" y="12" width="16" height="16" fill="#fff"/>`,
  ),
  nz: svg(
    `<rect width="60" height="40" fill="#00247D"/><rect width="30" height="20" fill="#012169"/><path d="M0 0 L30 20 M30 0 L0 20" stroke="#fff" stroke-width="4"/><path d="M15 0 V20 M0 10 H30" stroke="#fff" stroke-width="6"/><path d="M15 0 V20 M0 10 H30" stroke="#C8102E" stroke-width="3"/><g fill="#fff"><path d="M46 10 l1 3 h3 l-2.4 1.8 .9 3 L46 16 l-2.5 1.8 .9-3 L42 13 h3 z"/><path d="M46 26 l1 2.4 h2.6 l-2 1.6 .8 2.4 L46 30.6 l-2.4 1.8 .8-2.4 -2-1.6 h2.6 z"/></g>`,
  ),
};

export function flagMarkup(id: string): string {
  return FLAGS[id] ?? barsH('#5B92E5', '#fff', '#5B92E5');
}
